import React, { useEffect, useState } from "react";
import { SuccessConfetti } from "@assets/images";
import { RegistrationShell } from "../components/RegistrationShell";
import { RegistrationIcon } from "../components/RegistrationIcon";
import { useGeniusRegistration } from "../GeniusRegistrationContext";
import styles from "../GeniusRegistrationModal.module.css";
const SuccessBadgeFallback = () => (
  <div className={styles.successBadge} aria-hidden>
    ✓
  </div>
);

const REDIRECT_SECONDS = 5;

export const SuccessStep = () => {
  const { closeRegistration } = useGeniusRegistration();
  const [secondsLeft, setSecondsLeft] = useState(REDIRECT_SECONDS);

  useEffect(() => {
    if (secondsLeft <= 0) {
      closeRegistration();
      return undefined;
    }

    const timer = window.setTimeout(() => {
      setSecondsLeft((prev) => prev - 1);
    }, 1000);

    return () => window.clearTimeout(timer);
  }, [secondsLeft, closeRegistration]);

  return (
    <RegistrationShell onClose={closeRegistration} centerTitle>
      <div className={styles.successWrap}>
        <div className={styles.successConfettiWrap}>
          <img src={SuccessConfetti} alt="" className={styles.successConfetti} aria-hidden />
          <RegistrationIcon
            name="successBadge"
            className={styles.successIcon}
            fallback={SuccessBadgeFallback}
          />
        </div>        <h3 className={styles.successTitle}>Registration successful!</h3>
        <p className={styles.successText}>Our team will get in touch with you shortly.</p>
        <button
          type="button"
          className={`${styles.primaryBtn} ${styles.primaryBtnActive}`}
          onClick={closeRegistration}
        >
          Explore Infinity Learn
        </button>
        <p className={styles.redirectText}>
          Redirecting in <strong>{secondsLeft} seconds</strong>...
        </p>
      </div>
    </RegistrationShell>
  );
};
